const adminEmail = process.env.REACT_APP_ADMIN_EMAIL;

const checkIsAdmin = (userEmail) => {
  if (userEmail === adminEmail) {
    return true;
  }
  return false;
} 

export default checkIsAdmin;